// JavaScript Document

// Scripts written by __gulp_init_author_name__ @ __gulp_init_author_company__

import handorgel from "handorgel";

const UPDATE_VIA_HASH = (handorgel, hash) => {
    const TARGET_ID  = hash.replace(/^#/, "");
    const OLD_TARGET = document.querySelector(".hash-target");

    if (OLD_TARGET) {
        OLD_TARGET.classList.remove("hash-target");
    }

    requestAnimationFrame(() => {
        handorgel.folds.forEach((fold) => {
            if ((TARGET_ID.match(/^[A-Za-z]/) && fold.content.querySelector(`#${TARGET_ID}`)) || fold.header.dataset.id === TARGET_ID) {
                fold.open();
            }

            if (fold.header.dataset.id === TARGET_ID) {
                fold.header.classList.add("hash-target");
            } else if (hash.match(/^#[A-Za-z]/)  && fold.content.querySelector(hash)) {
                fold.content.querySelector(hash).classList.add("hash-target");
            }
        });
    });
};

const PARAMS     = new URLSearchParams(window.location.search);
const ACCORDIONS = document.querySelectorAll(".weblinx-accordions");

ACCORDIONS.forEach((element) => {
    const ACCORDION = new handorgel(element, {
        headerElements:       ".weblinx-accordion__header",
        contentElements:      ".weblinx-accordion__content",
        headerOpenClass:      "weblinx-accordion__header--open",
        contentOpenClass:     "weblinx-accordion__content--open",
        headerOpenedClass:    "weblinx-accordion__header--opened",
        contentOpenedClass:   "weblinx-accordion__content--opened",
        headerFocusClass:     "weblinx-accordion__header--focus",
        contentFocusClass:    "weblinx-accordion__content--focus",
        headerDisabledClass:  "weblinx-accordion__header--disabled",
        contentDisabledClass: "weblinx-accordion__content--disabled",
    });

    /**
     * Open accordions targeted by Relevanssi
     */
    if (PARAMS.get("highlight")) {
        ACCORDION.folds.forEach((fold) => {
            if (fold.content.querySelector("mark")) {
                fold.open();
            }
        });
    }

    /**
     * Open accordions targeted by a URL hash on hashchange
     */
    window.addEventListener("hashchange", () => {
        UPDATE_VIA_HASH(ACCORDION, window.location.hash);
    });

    /**
     * Open accordions targeted by a URL hash on load
     */
    if (window.location.hash) {
        UPDATE_VIA_HASH(ACCORDION, window.location.hash);
    }

    /**
     * Scroll to hash when an accordion finishes opening
     */
    ACCORDION.on("fold:opened", (fold) => {
        requestAnimationFrame(() => {
            if (window.location.hash && (fold.header.classList.contains("hash-target") || fold.content.querySelector(".hash-target") || (window.location.hash.match(/^#[A-Za-z]/) && (fold.header.querySelector(window.location.hash) || fold.content.querySelector(window.location.hash))))) {
                document.querySelector(".hash-target").scrollIntoView();
            } else {
                window.location.hash = fold.header.dataset.id;
            }
        });
    });

    /**
     * Fix Firefox bug
     */
    ACCORDION.on("fold:close", (fold) => {
        setTimeout(() => {
            fold.header.classList.remove("weblinx-accordion__header--open");
            fold.content.classList.remove("weblinx-accordion__content--open");
        }, 100);
    });
});
